module.exports = __webpack_public_path__ + "img/google-my-business-phone.67657bea.png";